import Reflux from 'reflux'
import Proxies from 'Components/proxies'
const { GET, POST } = Proxies
import keyMirror from 'keymirror'
import 'moment/locale/da'

export const STATUS = keyMirror({
  IS_FETCHING: null,
  FETCHING_ERROR: null,
  UPDATE_SUCCESS: null,
  UPDATE_ERROR: null,
  DELETE_ERROR: null,
  DELETE_SUCCESS: null,
  TAKING_INPUT: null,
  IS_SAVING: null,
  REDIRECT: null
})

export const ColorCategoryActions = Reflux.createActions([
  'getColorCategories',
  'deleteColorCategory',
  'clearToast',
  'createEmptyColorCategory',
  'clearFormToast',
  'updateColorCategoryField',
  'saveColorCategory',
  'getColorCategoryDetails'
])

export class ColorCategoryStore extends Reflux.Store {
  constructor(props) {
    super(props)
    this.listenables = ColorCategoryActions
    this.state = {
      status: null,
      colorCategories: [],
      colorCategoryName: null,
      colorCategoryDetails: {
        name: '',
        hexCode: ''
      },
      groups: []
    }
  }

  getColorCategories() {
    if (this.state.status === STATUS.IS_FETCHING) {
      return
    }

    this.setState({ status: STATUS.IS_FETCHING })
    GET('colorCategories/pool').then(responseJSON => {
      let nextState = {
        colorCategories: []
      }
      if (responseJSON) {
        if (responseJSON.error) {
          nextState.status = STATUS.FETCHING_ERROR
        } else {
          nextState.colorCategories = responseJSON
          nextState.status = null
        }
      }
      this.setState(nextState)
    })
  }

  clearToast() {
    this.setState({ status: null })
  }

  deleteColorCategory(id = null) {
    if (id) {
      POST('colorCategories/remove', { ColorCategoryID: id }).then(responseJSON => {
        if (responseJSON.error) {
          this.setState({ status: STATUS.DELETE_ERROR })
        } else {
          this.getColorCategories()
        }
      })
    }
  }

  createEmptyColorCategory() {
    this.setState({
      colorCategoryDetails: {
        name: '',
        hexCode: ''
      }
    })
  }

  clearFormToast(status) {
    status ? this.setState({ status }) : this.setState({ status: STATUS.TAKING_INPUT })
  }

  getColorCategoryDetails(id = null) {
    if (!id) {
      return
    }

    this.setState({ status: STATUS.IS_FETCHING })
    GET('colorCategories/fetch', { ColorCategoryID: id }).then(responseJSON => {
      let nextState = {
        colorCategoryDetails: {}
      }
      if (responseJSON) {
        if (responseJSON.error) {
          nextState.status = STATUS.FETCHING_ERROR
        } else {
          nextState.colorCategoryDetails = responseJSON
          nextState.status = STATUS.TAKING_INPUT
        }
      }
      this.setState(nextState)
    })
  }

  updateColorCategoryField(field) {
    let fieldName = field.target.name
    let fieldValue
    if (fieldName === 'isActive' || fieldName === 'isHideable') {
      fieldValue = field.target.checked ? 1 : 0
    } else if (fieldName === 'poolOrder') {
      fieldValue = Number(field.target.value)
    } else {
      fieldValue = field.target.value
    }
    let colorCategoryDetails = this.state.colorCategoryDetails
    colorCategoryDetails[fieldName] = fieldValue
    this.setState({ colorCategoryDetails })
  }

  saveColorCategory() {
    let colorCategoryDetails = this.state.colorCategoryDetails
    if (!colorCategoryDetails.timeEnd) {
      colorCategoryDetails.timeEnd = null
    }
    this.setState({ status: STATUS.IS_SAVING })
    POST('colorCategories/replace', colorCategoryDetails).then(responseJSON => {
      if (responseJSON) {
        if (responseJSON.error) {
          this.setState({ status: STATUS.UPDATE_ERROR })
        } else {
          this.setState({ status: STATUS.UPDATE_SUCCESS })
        }
      }
    })
  }
}
